import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ImageLightbox.scss';

interface ImageLightboxProps {
    src: string;
    onClose: () => void;
}

export const ImageLightbox = ({ src, onClose }: ImageLightboxProps) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.body.style.overflow = 'unset';
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [onClose]);

    return ReactDOM.createPortal(
        <div className="image-lightbox-overlay" onClick={onClose}>
            <button className="image-lightbox-close" onClick={onClose} aria-label="Close">✕</button>
            <img
                className="image-lightbox-img"
                src={src}
                alt=""
                onClick={(e) => e.stopPropagation()}
            />
        </div>,
        document.body
    );
};

export default ImageLightbox;
